import { Component, ChangeDetectionStrategy, signal, inject, input, output } from "@angular/core";
import { ITag } from "../../../../core-ui/models/interfaces";
import { CardComponent } from "../card/card.component";

@Component({
  selector: "av-tag-manager",
  templateUrl: "./tag-manager.component.html",
  styleUrls: ["./tag-manager.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TagManagerComponent {
  private card = inject(CardComponent, { optional: true });

  readonly items = input<ITag[]>(undefined);
  readonly placeholder = input<string>("");

  readonly changed = output<ITag[]>();

  newItemValue: string;
  color = signal<string>("basic");

  constructor() {
    const card = this.card;

    if (!!card) {
      this.color.set("accent");
    }
  }

  itemRemoved(tag: ITag) {
    this.changed.emit(this.items().filter((t) => t.value !== tag.value));
  }

  addItem(value: string) {
    if (!value) {
      return;
    }
    const items = this.items();
    if (items.some((t) => t.value === value)) {
      return;
    }
    this.newItemValue = undefined;
    this.changed.emit([
      ...items,
      { value: value.trim(), label: value.trim() },
    ]);
  }
}
